import PropTypes from "prop-types"
import React, { useState, useEffect, useContext } from "react"
import { Collapse, Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { toggleLeftmenu } from "../../store/actions";
//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"
import { customerRoutes } from "../../routes/customer"
import { CartContext } from "context/cartContext"
import { WishlistContext } from "context/wishlistContext"
import { uId } from "common/utility"
import classNames from "classnames"

const Navbar = props => {
  const { cartLength, getCartData } = useContext(CartContext)
  const { getWishlistData, wishlistLength } = useContext(WishlistContext)
  const [orderOpen, setOrderOpen] = useState(false);

  useEffect(() => {
    let matchingMenuItem = null
    let ul = document.getElementById("navigation")
    let items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (let item of items) {
      if (window.location.pathname === item.pathname) {
        matchingMenuItem = item
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (let item of items) {
      const parent = item.parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active")
      const parent2 = parent.parentElement
      parent2.classList.add("active")
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active")
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active")
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active")
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active")
            }
          }
        }
      }
    }
    return false
  }

  const [open, setOpen] = useState(false)

  const toggleLeftCanvas = () => {
    setOpen(!open)
  }

  useEffect(() => {
    getCartData()
    getWishlistData()
  }, [])

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {customerRoutes.map(
                  (nav, i) =>
                    !nav.hideMenu && (
                      <li className="nav-item dropdown" key={i}>
                        {nav.displayName === "My Orders" ? (
                          <>
                            <Link
                              className="nav-link dropdown-toggle arrow-none"
                              onClick={() => {
                                setOrderOpen(!orderOpen);
                              }}
                              to={"#"}
                            >
                              <i className="bx bxs-shopping-bag me-2"></i>
                              {props.t(nav.displayName)}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              style={{ backgroundColor: '#344fa0', color: 'white', paddingLeft: '15px' }}
                              className={classNames("dropdown-menu", { show: orderOpen })}
                            >
                              <Link
                                className="dropdown-item nav-link"
                                to="/customer/order-request"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false)
                                }}
                              >
                                {props.t("Order Request")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/orders"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false)
                                }}
                              >
                                {props.t("Orders")}
                              </Link>
                            </div>
                          </>
                        ) : nav.displayName === "Reports" ? (
                          <>
                            <Link
                              className="nav-link dropdown-toggle arrow-none"
                              onClick={() => {
                                setOrderOpen(!orderOpen);
                              }}
                              to={"#"}
                            >
                              <i className="bx bxs-shopping-bag me-2"></i>
                              {props.t(nav.displayName)}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              style={{ backgroundColor: '#344fa0', color: 'white', paddingLeft: '15px' }}
                              className={classNames("dropdown-menu", { show: orderOpen })}
                            >
                              <Link className="dropdown-item nav-link" to="/customer/orderRequestReport"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false)
                                }}
                              >
                                {props.t("Order Request Report")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/orderReport"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false);
                                }}
                              >
                                {props.t("Order Report")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/ledgerReport"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false);
                                }}
                              >
                                {props.t("Ledger Report")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/targetVsActual"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false);
                                }}
                              >
                                {props.t("Target Vs Actual Sale")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/mtdSalesReport"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false);
                                }}
                              >
                                {props.t("MTD Sales Report")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/pendingOrderSalesReport"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false);
                                }}
                              >
                                {props.t("Order Sales Report")}
                              </Link>
                            </div>
                          </>
                        ) : nav.displayName === "Inquiry" ? (
                          <>
                            <Link
                              className="nav-link dropdown-toggle arrow-none"
                              onClick={() => {
                                setOrderOpen(!orderOpen);
                              }}
                              to={"#"}
                            >
                              <i className="bx bx-message-alt-dots me-2"></i>
                              {props.t(nav.displayName)}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              style={{ backgroundColor: '#344fa0', color: 'white', paddingLeft: '15px' }}
                              className={classNames("dropdown-menu", { show: orderOpen })}
                            >
                              <Link
                                className="dropdown-item nav-link"
                                to="/customer/product-inquiry"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false)
                                }}
                              >
                                {props.t("Product Inquiry")}
                              </Link>
                              <Link className="dropdown-item nav-link" to="/customer/query"
                                onClick={() => {
                                  props.toggleLeftmenu(false);
                                  setOrderOpen(false)
                                }}
                              >
                                {props.t("Query")}
                              </Link>
                            </div>
                          </>
                        ) : (
                          <Link className="nav-link" to={nav.path}
                            onClick={() => {
                              props.toggleLeftmenu(false);
                            }}
                          >
                            <i className={`${nav.icon} me-2`}></i>
                            {props.t(nav.displayName)}
                            {nav.displayName === "Cart" && (
                              <span
                                className="bg-warning rounded-pill"
                                style={{
                                  margin: "0px 0px 0px 5px",
                                  color: "white",
                                }}
                              >
                                {cartLength}
                              </span>
                            )}
                            {nav.displayName === "Wishlist" && (
                              <span
                                className="bg-warning rounded-pill"
                                style={{
                                  margin: "0px 0px 0px 5px",
                                  color: "white",
                                }}
                              >
                                {wishlistLength}
                              </span>
                            )}
                          </Link>
                        )}
                      </li>
                    )
                )}

                <Offcanvas
                  className="dealer"
                  isOpen={open}
                  toggle={toggleLeftCanvas}
                >
                  <OffcanvasHeader toggle={toggleLeftCanvas}>
                    Hello Ajit,
                  </OffcanvasHeader>
                  <OffcanvasBody></OffcanvasBody>
                </Offcanvas>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  orderOpen: PropTypes.bool,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, { toggleLeftmenu })(withTranslation()(Navbar))
)

